import _ from 'lodash';
import { Sessions } from '@or-sdk/hitl';
import { ISession, Writeable } from '@/types';

type ModifyParam = Sessions.Session | Sessions.Session[];
type ModifyReturn<T> = T extends Sessions.Session
  ? ISession
  : T extends Sessions.Session[]
    ? ISession[]
    : never;

/**
 * Transform some session's properties for easier access.
 * TODO: HITL Session ID is copied for temporary compatibility and can be removed later.
 */
export const modify = <T extends ModifyParam>(args: T): ModifyReturn<T> => {
  const sessions: Sessions.Session[] = args instanceof Array ? args : [args];
  const objects: ISession[] = [];

  for (const session of sessions) {
    const obj: Writeable<ISession> = {
      ..._.omit(session, ['eventTimestamp', 'closedAt']),
      sessionId: session.hitlSessionId,
      createdAt: new Date(session.createdAt || 0),
      updatedAt: new Date(session.updatedAt || 0),
    };

    if (session.eventTimestamp) {
      obj.eventTimestamp = new Date(session.eventTimestamp);
    }
    if (session.closedAt) {
      obj.closedAt = new Date(session.closedAt);
    }

    objects.push(obj);
  }

  return (args instanceof Array ? objects : objects[0]) as ModifyReturn<T>;
};

export const SEARCH_SESSIONS_CHUNK_SIZE = 100;
export const COMMANDS = {
  SEND_MESSAGE: 'send_message',
  NOT_CLAIMED: 'notclaimed',
  CLAIM_TIMEOUT: 'claim-timer',
};

export const REJECT_REASONS = {
  ANOTHER_POPUP_ACTIVE: 'ANOTHER_POPUP_ACTIVE',
  AGENT_UNAVAILABLE: 'AGENT_UNAVAILABLE',
};

/* eslint-disable-next-line @typescript-eslint/naming-convention */
export enum CONTACT_HISTORY_STATUS {
  NONE = 'NONE',
  LOADING = 'LOADING',
  READY = 'READY',
}
